
import {  Observable } from 'rxjs';
//import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { throwError } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable }                       from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';



//import { Http, Headers, 
//        Response, RequestOptions }          from '@angular/http';
import { Mainref, User, Ops, Credentials }                             from '../_models/index';
import * as CryptoJS                        from 'crypto-js';
import { environment }                      from '../../environments/environment';

@Injectable()

export class UserService {
    private apiUrl = environment.apiurl;
    private referralUrl = environment.gdocsurl;
    constructor(private httpClient: HttpClient) { }

    getAll(id_token: string) {
        return this.httpClient.get(this.apiUrl+'entity', this.getHeaderOptions(id_token)).pipe(map((response: any) => response));
        //const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        //return this.httpClient.get(this.apiUrl+'entity', {headers}).pipe(map((response: any) => response));        
        
    }

    getById(id: number, id_token: string) {
        return this.httpClient.get(this.apiUrl+'entity/' + id, this.getHeaderOptions(id_token)).pipe(map((response: any) => response));
        //const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        //return this.httpClient.get(this.apiUrl+'entity/' + id, {headers}).pipe(map((response: any) => response));
    }

    create(user: User) {
        var userUpd: User = {} as User;
        userUpd.email = user.email?.toLowerCase().trim();
        userUpd.prefix = (user.prefix !== undefined) ? user.prefix : "" ;
        userUpd.firstname = user.firstname;
        userUpd.lastname = user.lastname;
        userUpd.phone = (user.phone !== undefined) ? user.phone : "" ;
        userUpd.password = CryptoJS.MD5(user.password || '') + "";
        //alert('CREATE:' + JSON.stringify(user));
        //alert('URL:'+this.apiUrl+'entity/checkCreateEntity')
        /*var httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json', //'Content-Type':  'text/plain', //Authorization: id_token
            })
          };*/
        //return this.httpClient.post(this.apiUrl+'entity/checkCreateEntity', userUpd, httpOptions).pipe(map((response: JSON) => response));
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.httpClient.post(this.apiUrl+'entity/checkCreateEntity', userUpd, {headers}).pipe(map((response: any) => response));        
    }

    activate(id_token: string){//alert(id_token);//alert(this.apiUrl+'entity/activate');
        return this.httpClient.post(this.apiUrl+'entity/activate', '', this.getHeaderOptions(id_token)).pipe(map((response: any) => response));
        //const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: id_token });
        //return this.httpClient.post(this.apiUrl+'entity/activate', '', {headers}).pipe(map((response: any) => response));        
    }

    forgotyourpassword(user: User){
        /*var httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json', //'Content-Type':  'text/plain', //Authorization: id_token
            })
          };
        return this.httpClient.post(this.apiUrl+'entity/forgotYourPassword', user, httpOptions).pipe(map((response: JSON) => response));*/
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.httpClient.post(this.apiUrl+'entity/forgotYourPassword', user, {headers}).pipe(map((response: any) => response));        
    }

    resetyourpassword(cred: Credentials, id_token: string){
        var userUpd:User = {};        
        userUpd.email = cred.email?.toLowerCase().trim();
        /*userUpd.prefix = user.prefix;
        userUpd.firstname = user.firstname;
        userUpd.lastname = user.lastname;
        userUpd.phone = user.phone;*/
        userUpd.password = CryptoJS.MD5(cred.password || '') + "";
        return this.httpClient.post(this.apiUrl+'entity/resetYourPassword', userUpd, this.getHeaderOptions(id_token)).pipe(map((response: any) => response));
        //const headers = new HttpHeaders({ 'Content-Type': 'application/json' });        
        //return this.httpClient.post(this.apiUrl+'entity/resetYourPassword', userUpd, {headers}).pipe(map((response: any) => response));
    }


    update(user: User, id_token: string) {
      return this.httpClient.delete(this.apiUrl+'entity/' + user.entityid, this.getHeaderOptions("id_token")).pipe(map((response: any) => response));      
        //const headers = new HttpHeaders({ 'Content-Type': 'application/json' });        
        //return this.httpClient.put(this.apiUrl+'entity/' + user.entityid, user, {headers}).pipe(map((response: any) => response));
    }

    delete(entityid: number, id_token: string) {
        return this.httpClient.delete(this.apiUrl+'entity/' + entityid, this.getHeaderOptions("id_token")).pipe(map((response: any) => response));
        //const headers = new HttpHeaders({ 'Content-Type': 'application/json' });        
        //return this.httpClient.delete(this.apiUrl+'entity/' + entityid, {headers}).pipe(map((response: any) => response));
    }

    /*private jwt(id_token) {
        // create authorization header with jwt token
        //if (id_token === false){
        //    return false;
        //}
        let headers = new Headers();
        //headers.append('Authorization', 'Bearer '+id_token);
        //headers.append('Access-Control-Allow-Headers',  'Content-Type, X-Auth-Token, Origin, Authorization');
        //headers.append('Content-Type','application/json');
        if (id_token != ""){
            headers.append('Authorization', id_token);
        }
        return new RequestOptions({ headers: headers });
    }*/


    // Organization
    orgRegisterEmail(mainref: Mainref) {
        //var mainrefData = '{"ops":"registerMainrefEmail", "refemail":"'+mainref.refemail+'" , "reffirstname":"'+mainref.reffirstname+'"  , "reflastname":"'+mainref.reflastname+'"  , "refcompany":"'+mainref.refcompany+'"  , "phone":"'+mainref.phone+'" }';
        //let headers = new Headers();
                
        //var options = new RequestOptions({ headers: headers });
        /*var httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json', //'Content-Type':  'text/plain', //Authorization: id_token
            })
          };*/
          /*return this.httpClient.post(this.referralUrl, mainrefData, {headers}).pipe(
            map((response: any) => response.json()));*/

       /*return this.httpClient.post(this.referralUrl, mainrefData, {headers}).pipe(
            map((response: JSON) => response),
            catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);*/
      const mainrefObj = {
        ops: "registerMainrefEmail",
        refemail: mainref.refemail,
        reffirstname: mainref.reffirstname,
        reflastname: mainref.reflastname,
        refcompany: mainref.refcompany,
        phone: mainref.phone
      };
      var mainrefData = JSON.stringify(mainrefObj);
       const headers = new HttpHeaders({ 'Content-Type': 'application/json' });        
      return this.httpClient.post<any>(this.referralUrl, mainrefData, {headers}).pipe(
        map((response: any) => response),
        catchError((err: any, caught: Observable<any>) => throwError(() => (err) ? err : 'Server error: '+err.text())),
      );
    }

     orgForgotyourpassword(user: User){
        /*var httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json', //'Content-Type':  'text/plain', //Authorization: id_token
            })
          };*/

        /*return this.httpClient.post(this.apiUrl+'mainref/forgotYourPassword', user, httpOptions).pipe(
            map((response: any) => response),
            catchError((err:any, caught: Observable<any>) => ErrorObservable.create((err) ? (err) : 'Server error: '+err.text()) ),);*/

        //return this.httpClient.post(this.apiUrl+'mainref/forgotYourPassword', user, httpOptions).pipe(map((response: any) => response));
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });        
        return this.httpClient.post(this.apiUrl+'mainref/forgotYourPassword', user, {headers}).pipe(map((response: any) => response));
    }

    orgResetyourpassword(cred: Credentials, id_token: string){
        var userUpd:User = {};        
        userUpd.email = cred.email?.toLowerCase().trim();
        /*userUpd.prefix = user.prefix;
        userUpd.firstname = user.firstname;
        userUpd.lastname = user.lastname;
        userUpd.phone = user.phone;*/
        userUpd.password = CryptoJS.MD5(cred.password || '') + "";

        return this.httpClient.post(this.apiUrl+'mainref/resetYourPassword', userUpd, this.getHeaderOptions(id_token)).pipe(map((response: any) => response));
        //const headers = new HttpHeaders({ 'Content-Type': 'application/json' });        
        //return this.httpClient.post(this.apiUrl+'mainref/resetYourPassword', userUpd, {headers}).pipe(map((response: any) => response));
    }

    // Call refauth first to set email id to validated and then call Gdocs URL:
    startOpsProcess(cred: Credentials){//alert(id_token);//alert(this.apiUrl+'entity/activate');
        var opspassword = CryptoJS.MD5(cred.password) + "";
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
          var opsuser  = JSON.stringify({
              opsid : "00009292920000",
              opsemail : cred.email?.toLowerCase().trim(),
              opspassword : opspassword
          });
        return this.httpClient.post(this.apiUrl+'login/ops/entityStartProcess', opsuser , {headers}).pipe(map((response: any) => response));
    }

// GDOCSURL
    startProcess(link: String, credentials: Credentials){
        var pwd =   CryptoJS.MD5(credentials.password || '') + "";  
        //var linkData = '{"ops":"start-process", "link":"'+link+'" , "password":"'+pwd+'"}';
        //let headers = new Headers();
                
        //var options = new RequestOptions({ headers: headers });

/*        return this.httpClient.post(this.referralUrl, linkData, {headers}).pipe(
            map((response: any) => response),
            catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);            */
        var linkData = JSON.stringify({
          ops: "start-process",
          link: link,
          password: pwd,
        });
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });        
        return this.httpClient.post(this.referralUrl, linkData, {headers}).pipe(
            map((response: any) => response),
            catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);            
    }

    checkQuestionnaireStatus(refid: String, referralid: String, linktype: String, scd: String){
        //var postData = '{"ops":"checkQuestionnaireStatus", "refid":"'+refid+'" , "referralid":"'+referralid+'" ,"linktype":"'+linktype+'" , "scd":"'+scd+'"}';
        //let headers = new Headers();
                
        //var options = new RequestOptions({ headers: headers });
        /*return this.httpClient.post(this.referralUrl, postData, {headers}).pipe(
            map((response: any) => response),
            catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);            */

        const postData = {
          ops: "checkQuestionnaireStatus",
          refid: refid,
          referralid: referralid,
          linktype: linktype,
          scd: scd
        };

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });        
        return this.httpClient.post(this.referralUrl, postData, {headers}).pipe(
            map((response: any) => response),
            catchError((err:any, caught: Observable<any>) => throwError(() => (err) ? (err) : 'Server error: '+err.text()) ),);            

    }

    private getHeaderOptions(id_token: string){
        // //let headers = new Headers();
         //headers.append('Content-Type', 'text/plain');
         //headers.append('Authorization', id_token);
         //headers.append('Access-Control-Allow-Origin', 'https://script.googleusercontent.com');
         //headers.append('Access-Control-Allow-Origin', '*');
       //  //return new RequestOptions({ headers: headers });
     
       if (id_token != ""){
             var httpOptions = {
               headers: new HttpHeaders({
                 'Content-Type':  'application/json',
                 //'Content-Type':  'text/plain',
                 Authorization: id_token
               })
             };
           }else{
             var httpOptions = {
               headers: new HttpHeaders({
                 'Content-Type':  'application/json',
                 //'Content-Type':  'text/plain',
                 //Authorization: id_token
               })
             };
           }
             return httpOptions;
      }
     
}